import States from "@/entities/locationEntities/States";
import Provinces from "@/entities/locationEntities/Provinces";

const isPrimaryCountryStates = (regions: string[]) => {
  const states = Object.values(States);
  const provinces = Object.values(Provinces);

  return [...states, ...provinces].some(defaultRegion => regions.some(region => defaultRegion === region));
}

export default isPrimaryCountryStates;